import React from "react";
import {
  Button,
  Col,
  Container,
  FormControl,
  FormLabel,
  Row,
} from "react-bootstrap";
import { ConfigManager } from "../config/ConfigManager.js";
import {
  CustomerSearchCriteria,
  FabricStyleSearchCriteria,
  InvoiceSearchCriteria,
  PageListBean,
  RestCustomerListRequest,
  RestFabricStyleListBeanRequest,
  RestInvoiceListRequest,
  RestPageListBean,
  RestReadRequest,
} from "../ds/ds.js";
import { LookupHandler, LookupResultDetails } from "../ds/lookup_ds.js";
import { Eraser, TickIcon } from "../gui_components/Icons.js";
import {
  DatePickerComponent,
  InputTextbox,
  ShowError,
  ProgressBar,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { ModuleUtils } from "../modules/ModuleUtils.js";
import { CustomerService } from "../services/CustomerService.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { InvoiceService } from "../services/InvoiceService.js";
export class InvoiceLookupHandlers extends LookupHandler {
  constructor(companyCode, attribute_name, searchCode, status) {
    super();
    this.state = {
      is3PL: false,
    };
    this.attribute_name = attribute_name;
    this.lookupTitle = attribute_name + " Lookup";
    this.companyCode = companyCode;
    this.searchCode = searchCode;
    this.status = status;
    let resetCriteria = new InvoiceSearchCriteria();
    resetCriteria.companyCode = companyCode;
    this.resetCriteria = resetCriteria;
    let invoiceLookupCriteria = new InvoiceSearchCriteria();
    invoiceLookupCriteria.companyCode = this.companyCode;
    invoiceLookupCriteria.customerCode = this.searchCode;
    invoiceLookupCriteria.invoiceStatus = this.status;
    let newCriteria = new InvoiceSearchCriteria();
    newCriteria.companyCode = companyCode;
    this.newCriteria = newCriteria;
    let lookupCriteriaView = InvoiceLookupCriteraHandler(
      companyCode,
      invoiceLookupCriteria
    );
    let lookupDataCallback = function (
      lookup_dialog,
      page_number,
      searchCriteria,
      filterText
    ) {
      this.fetchDataFromService(
        lookup_dialog,
        page_number,
        searchCriteria,
        filterText
      );
    };
    this.setDetails(
      lookupDataCallback,
      invoiceLookupCriteria,
      lookupCriteriaView
    );
    ModuleUtils.getInvoiceStatusList();
    this.initColumns();
  }
  componentDidMount() {
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
  }
  initColumns() {
    this.addColumnDefinition(this.attribute_name, "code", 0, true); //1
    this.addColumnDefinition("Status", "invoiceStatus", 0, false); //3
    this.addColumnDefinition("InvoiceDate", "createdDate", 0, false);
    this.addColumnDefinition(" SO#", "salesOrderNumber", 0, false); //1
    this.addColumnDefinition("PickTicket", "pickTicketNumber", 0, false); //3
    this.addColumnDefinition("CustomerCode", "customerCode", 0, false); //3
    this.addColumnDefinition("CustomerName", "customerName", 0, false); //3
    this.addColumnDefinition(
      this.state.is3PL ? "Items" : "FabricStyles",
      "fabricStyles",
      0,
      false
    );
    this.addColumnDefinition(
      "CustPO#",
      "customerPurchaseOrderNumber",
      0,
      false
    );
    this.addColumnDefinition("ContainerNumber#", "containerNumber", 0, false);

    this.addColumnDefinition("GrandTotalAmount", "grandTotalAmount", 1, false); //3
  }
  loadInvoiceList = (lookup_dialog, pageNumber, searchCriteria) => {
    let inv_criteria = new InvoiceSearchCriteria(); //To be fetched from CriteriaHandler
    inv_criteria.companyCode = this.companyCode;
    if (searchCriteria !== undefined && searchCriteria !== null) {
      inv_criteria.invoiceNumberStartsWith =
        searchCriteria.invoiceNumberStartsWith;
      inv_criteria.invoiceNumberContains = searchCriteria.invoiceNumberContains;
      inv_criteria.invoiceNumber = searchCriteria.invoiceNumber;
      inv_criteria.pickTicketNumber = searchCriteria.pickTicketNumber;
      inv_criteria.salesOrderNumber = searchCriteria.salesOrderNumber;
      inv_criteria.customerCode = searchCriteria.customerCode;
      inv_criteria.fabricStyleCode = searchCriteria.fabricStyleCode;
      inv_criteria.invoiceDate = searchCriteria.invoiceDate;
      inv_criteria.invoiceGrandTotalAmount =
        searchCriteria.invoiceGrandTotalAmount;
      inv_criteria.customerPurchaseOrderNumber =
        searchCriteria.customerPurchaseOrderNumber;
      inv_criteria.colorCode = searchCriteria.colorCode;
      inv_criteria.displayOption = searchCriteria.displayOption;
      inv_criteria.containerNumber = searchCriteria.containerNumber;
      if (!isEmptyString(this.searchCode)) {
        inv_criteria.customerCode = this.searchCode;
      } else {
        inv_criteria.customerCode = searchCriteria.customerCode;
      }
      if (!isEmptyString(this.status)) {
        inv_criteria.invoiceStatus = this.status;
      } else {
        inv_criteria.invoiceStatus = searchCriteria.invoiceStatus;
      }
    }
    let inv_pageList = new PageListBean();
    inv_pageList.pageSize = 50; //TODO --> Fetch from Config
    inv_pageList.currentPage = pageNumber;
    inv_pageList.pageNumber = pageNumber;
    let inv_requestInput = new RestInvoiceListRequest();
    inv_requestInput.pageInput = inv_pageList;
    inv_requestInput.searchCriteria = inv_criteria;
    InvoiceService.getInvoicePageList(
      inv_requestInput,
      (response) => this.loadInvoiceListResponse(response, lookup_dialog),
      this.loadInvoiceListError
    );
  };
  loadInvoiceListResponse = (response, lookup_dialog) => {
    let invList = [];
    let totalCount = 0;
    let currentPageNumber = 0;
    let pageSize = 0;
    if (
      response.data.invoicePageList != null &&
      response.data.invoicePageList.invoices !== null
    ) {
      invList = response.data.invoicePageList.invoices;
      totalCount = response.data.invoicePageList.totalCount;
      currentPageNumber = response.data.invoicePageList.currentPage;
      pageSize = response.data.invoicePageList.pageSize;
      invList.map((inv) => {
        inv.invoiceStatus = ModuleUtils.getInvoiceStatusCaption(
          inv.invoiceStatus
        );
      });
    }
    let lookup_result_details = new LookupResultDetails();
    lookup_result_details.pageData = invList;
    let total_count = 0;
    if (this.lookup_data != null) {
      total_count = this.lookup_data.length;
    }
    lookup_result_details.totalRecordsCount = totalCount;
    lookup_result_details.currentPageNumber = currentPageNumber;
    lookup_result_details.pageSize = pageSize;
    lookup_result_details.criteriaDisplayString = ""; //TODO
    lookup_dialog.updateResultCallBack(lookup_result_details);
  };
  loadInvoiceListError = (error) => {
    ShowError("Error : " + error);
  };
  fetchDataFromService(lookup_dialog, pageNumber, searchCriteria, filterText) {
    let search = { ...searchCriteria };
    if (search != null && search != "undefined") {
      // if (isEmptyString(search.invoiceNumberContains)) {
      if (!isEmptyString(filterText)) {
        search.invoiceNumberContains = filterText;
        this.searchCriteria = new InvoiceSearchCriteria();
      }
    }
    if (lookup_dialog != null) {
      this.loadInvoiceList(lookup_dialog, pageNumber, search);
    }
  }
}
const InvoiceLookupCriteraHandler = (companyCode, invoiceLookupCriteria) => {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        searchCriteria: new InvoiceSearchCriteria(),
        customerPageListForAutoCompleteList: new Array(),
        fabricPageListForAutoCompleteList: new Array(),
        showAutoCompleteCustomerList: true,
        showAutoCompleteFabricList: true,
        isShowColorLookup: false,
        colorLookupHandler: null,
        fabricLookupHandler: null,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
        is3PL: false,
      };
      this.criteriaLookupHandler = React.createRef();
      this.focusRef = React.createRef();
    }
    componentDidMount() {
      let searchCriteria = this.state.searchCriteria;
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
        this.state.is3PL = true;
        this.setState({
          is3PL: true,
        });
      }
      if (this.focusRef.current) this.focusRef.current.focus();
      this.initLookupHandlers();
    }
    initLookupHandlers = () => {
      let customerLookupHandler = new CustomerLookupHandler(
        companyCode,
        "Customer"
      );
      this.setState({ customerLookupHandler: customerLookupHandler });
      let fabricLookupHandler = new FabricStyleLookupHandler(
        companyCode,
        this.state.is3PL ? "Item" : "Fabric Style"
      );
      this.setState({ fabricLookupHandler: fabricLookupHandler });
    };
    continueButtonClick = () => {
      this.props.searchCriteriaCallBack(this.state.searchCriteria);
    };
    onChange = (e) => {
      let temp_searchCriteria = this.state.searchCriteria;
      temp_searchCriteria[e.target.name] = e.target.value;
      this.setState({ searchCriteria: temp_searchCriteria });
    };
    clearCriteria = () => {
      let searchCriteria = new InvoiceSearchCriteria();
      searchCriteria.companyCode = companyCode;
      this.setState({
        searchCriteria: searchCriteria,
        isShowColorLookup: false,
        colorLookupHandler: null,
      });
      if (this.focusRef.current) this.focusRef.current.focus();
    };
    onContainerKeyDown = (e) => {
      if (e.ctrlKey && e.keyCode == "191") {
        this.continueButtonClick();
      }
    };
    fabricCodeOnChange = (e) => {
      let fabricStyleCode = e.target.value;
      this.state.showAutoCompleteFabricList = true;
      let tempCriteria = this.state.searchCriteria;
      let showAutoCompleteList = this.state.showAutoCompleteFabricList;
      if (isEmpty(fabricStyleCode)) {
        this.state.showAutoCompleteFabricList = false;
        let showAutoCompleteList = this.state.showAutoCompleteFabricList;
        let criteria = this.state.searchCriteria;
        criteria.fabricStyleCode = "";
        let suggestion = [];
        this.setState({
          showAutoCompleteFabricList: showAutoCompleteList,
          searchCriteria: criteria,
          fabricPageListForAutoCompleteList: suggestion,
        });
      } else if (
        e.target.name == "fabricStyleCode" &&
        showAutoCompleteList === true &&
        fabricStyleCode !== ""
      ) {
        this.readFabricBySearchString(e.target.value);
      }
      tempCriteria[e.target.name] = e.target.value;
      this.setState({ searchCriteria: tempCriteria });
    };
    readandsetFabricStyleDetailResponse = (response) => {
      let criteria = this.state.searchCriteria;
      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
      if (response.data != null && response.data.fabricStyle != null) {
        let fabricStyle = response.data.fabricStyle;
        if (!isEmpty(fabricStyle)) {
          criteria.fabricStyleCode = fabricStyle.code;
          this.setState({
            searchCriteria: criteria,
          });
        }
      }
    };
    readandsetFabricStyleDetail = (fabricStyleCode) => {
      let input = new RestReadRequest();
      input.companyCode = companyCode;
      input.code = fabricStyleCode;
      // input.isLoadChildren = true;
      FabricStyleService.readFabricStyle(
        input,
        this.readandsetFabricStyleDetailResponse,
        this.errorCallBack
      );
    };

    readFabricBySearchString(searchString) {
      let searchCriteria = new FabricStyleSearchCriteria();
      searchCriteria.companyCode = companyCode;
      searchCriteria.fabricStyleCodeStartsWith = searchString;
      searchCriteria.fabricStyleNameStartsWith = searchString;
      let pageList = new RestPageListBean();
      pageList.pageSize = 100;
      let input = new RestFabricStyleListBeanRequest();
      input.companyCode = companyCode;
      input.pageInput = pageList;
      input.code = searchString;
      input.searchCriteria = searchCriteria;
      FabricStyleService.getActiveFabricStylesForAutoComplete(
        input,
        this.readByFabricCodeResponse,
        this.errorCallBack
      );
    }
    readByFabricCodeResponse = (response) => {
      let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
      let simpleAutoCompleteList = new Array();
      if (fabricStyleData.length > 0 && fabricStyleData != null) {
        fabricStyleData.map((fabricStyle) => {
          let simpleItemBean = {
            code: fabricStyle.fabricStyleCode,
            description: fabricStyle.fabricStyleName,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      this.setState({
        fabricPageListForAutoCompleteList: simpleAutoCompleteList,
      });
    };
    fabricEnterKeyEventHandler = (e) => {
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Reading ...",
      });
      this.readandsetFabricStyleDetail(e.target.value);
      this.setState({ fabricPageListForAutoCompleteList: new Array() });
    };
    displayAutoCompleteFabricList = (showAutoCompleteFabricList) => {
      this.setState({ showAutoCompleteFabricList: showAutoCompleteFabricList });
    };
    customerCodeOnChange = (e) => {
      let customerCode = e.target.value;
      this.state.showAutoCompleteCustomerList = true;
      let tempCriteria = this.state.searchCriteria;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
      if (isEmpty(customerCode)) {
        this.state.showAutoCompleteCustomerList = false;
        let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
        let criteria = this.state.searchCriteria;
        criteria.customerCode = "";
        let suggestion = [];
        this.setState({
          showAutoCompleteCustomerList: showAutoCompleteList,
          searchCriteria: criteria,
          customerPageListForAutoCompleteList: suggestion,
        });
      } else if (
        e.target.name == "customerCode" &&
        showAutoCompleteList === true &&
        customerCode !== ""
      ) {
        this.readCustomerBySearchString(e.target.value);
      }
      tempCriteria[e.target.name] = e.target.value;
      this.setState({ searchCriteria: tempCriteria });
    };
    readCustomer = (customerCode) => {
      let input = new RestReadRequest();
      input.companyCode = companyCode;
      input.code = customerCode;
      // input.isLoadChildren = true;
      CustomerService.readCustomer(
        input,
        this.editCustomerResponse,
        this.errorCallBack
      );
    };
    editCustomerResponse = (response) => {
      if (response.data.customer != null) {
        let customerData = response.data.customer;
        let criteria = this.state.searchCriteria;
        criteria.customerCode = customerData.code;
        this.setState({ searchCriteria: criteria });
      }
    };
    readCustomerBySearchString(searchString) {
      let searchCriteria = new CustomerSearchCriteria();
      searchCriteria.companyCode = companyCode;
      searchCriteria.customerCodeStartsWith = searchString;
      searchCriteria.customerNameContains = searchString;
      let cust_pageList = new RestPageListBean();
      cust_pageList.pageSize = 100;
      let cust_requestInput = new RestCustomerListRequest();
      cust_requestInput.pageInput = cust_pageList;
      cust_requestInput.searchCriteria = searchCriteria;
      CustomerService.getCustomerPageList(
        cust_requestInput,
        this.readByCustomerCodeResponse,
        this.errorCallBack
      );
    }
    readByCustomerCodeResponse = (response) => {
      let customerData = response.data.customerPageList.customers;
      let simpleAutoCompleteList = new Array();
      if (customerData.length > 0 && customerData != null) {
        customerData.map((customer) => {
          let simpleItemBean = {
            code: customer.code,
            description: customer.description,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      this.setState({
        customerPageListForAutoCompleteList: simpleAutoCompleteList,
      });
    };
    errorCallBack = (error) => {
      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
      ShowError(error);
    };
    customerCodeEnterKeyEventHandler = (e) => {
      let customerCode = e.target.value;
      this.readCustomer(customerCode);
      this.setState({
        customerPageListForAutoCompleteList: new Array(),
      });
    };
    displayAutoCompleteList = (showAutoCompleteList) => {
      this.setState({
        showAutoCompleteCustomerList: showAutoCompleteList,
      });
    };
    render() {
      let searchCriteria = this.state.searchCriteria;
      const is3PL = this.state.is3PL;
      return (
        <div>
          <ProgressBar
            progressLoadingText={this.state.progressLoadingText}
            isShowPopup={this.state.isShowProgressBarPopup}
          />
          <Container onKeyDown={this.onContainerKeyDown}>
            <Row>
              <Col sm={5}>
                <FormLabel>Invoice Starts With</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="invoiceNumberStartsWith"
                  name="invoiceNumberStartsWith"
                  onChange={this.onChange}
                  value={searchCriteria.invoiceNumberStartsWith}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Invoice Contains</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="invoiceNumberContains"
                  name="invoiceNumberContains"
                  onChange={this.onChange}
                  value={searchCriteria.invoiceNumberContains}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Invoice#</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="invoiceNumber"
                  name="invoiceNumber"
                  onChange={this.onChange}
                  value={searchCriteria.invoiceNumber}
                />
              </Col>
            </Row>

            <Row>
              <Col sm={5}>
                <FormLabel>Status</FormLabel>
              </Col>
              <Col sm={7}>
                <FormControl
                  as="select"
                  custom
                  onChange={this.onChange}
                  name="invoiceStatus"
                  value={searchCriteria.invoiceStatus}
                >
                  <option value={""}></option>
                  <option value={"A"}>Approved</option>
                  <option value={"U"}>UnApproved</option>
                  <option value={"F"}>Paid</option>
                  <option value={"P"}>Partially Paid</option>
                  <option value={"X"}>Cancelled</option>
                </FormControl>
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>DisplayOption</FormLabel>
              </Col>
              <Col sm={7}>
                <FormControl
                  as="select"
                  custom
                  onChange={this.onChange}
                  name="displayOption"
                  value={searchCriteria.displayOption}
                >
                  <option value={0}>All</option>
                  <option value={1}>Merchandise</option>
                  <option value={2}>Non Merchandise</option>
                </FormControl>
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Customer</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  tabIndex={-1}
                  id="customerCode"
                  name="customerCode"
                  onChange={this.customerCodeOnChange}
                  value={searchCriteria.customerCode}
                  lookupRequired={true}
                  lookupHandler={this.state.customerLookupHandler}
                  showCriteriaDialog={true}
                  enterKeyEventHandler={this.customerCodeEnterKeyEventHandler}
                  autoCompleteListData={
                    this.state.customerPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayAutoCompleteList}
                  showAutoCompleteList={this.state.showAutoCompleteCustomerList}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                {is3PL ? (
                  <FormLabel>Item</FormLabel>
                ) : (
                  <FormLabel>FabricStyle#</FormLabel>
                )}
              </Col>
              <Col sm={7}>
                <InputTextbox
                  tabIndex={-1}
                  id="fabricStyleCode"
                  name="fabricStyleCode"
                  value={searchCriteria.fabricStyleCode}
                  onChange={this.fabricCodeOnChange}
                  lookupRequired={true}
                  lookupHandler={this.state.fabricLookupHandler}
                  showCriteriaDialog={true}
                  enterKeyEventHandler={this.fabricEnterKeyEventHandler}
                  autoCompleteListData={
                    this.state.fabricPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayAutoCompleteFabricList}
                  showAutoCompleteList={this.state.showAutoCompleteFabricList}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>CustomerPO#</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="customerPurchaseOrderNumber"
                  name="customerPurchaseOrderNumber"
                  onChange={this.onChange}
                  value={searchCriteria.customerPurchaseOrderNumber}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Invoice Date</FormLabel>
              </Col>
              <Col sm={7}>
                <DatePickerComponent
                  tabIndex={-1}
                  id="invoiceDate"
                  name="invoiceDate"
                  onChange={this.onChange}
                  value={searchCriteria.invoiceDate}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Invoice Amount</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="invoiceGrandTotalAmount"
                  name="invoiceGrandTotalAmount"
                  onChange={this.onChange}
                  value={searchCriteria.invoiceGrandTotalAmount}
                />
              </Col>
            </Row>
            {is3PL ? (
              <Row>
                <Col sm={5}>
                  <FormLabel>ConatinerNumber</FormLabel>
                </Col>
                <Col sm={7}>
                  <InputTextbox
                    id="containerNumber"
                    name="containerNumber"
                    onChange={this.onChange}
                    value={searchCriteria.containerNumber}
                  />
                </Col>
              </Row>
            ) : null}
            <div className="popup_criteria_button_align-lookup">
              <Button
                ref={this.focusRef}
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.continueButtonClick}
              >
                <TickIcon />
                Continue
              </Button>
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.clearCriteria}
              >
                <Eraser />
                Clear
              </Button>
            </div>
          </Container>
        </div>
      );
    }
  };
};
